export default function SourceChips({ sources = [] }) {
  if (!sources.length) return null;
  return (
    <div className="mt-2 flex flex-wrap gap-2">
      {sources.map((s, i) => (
        <a key={i} href={s.url || "#"} target="_blank" rel="noreferrer"
           className="text-xs px-2 py-1 rounded-full bg-amber-100 hover:bg-amber-200">
          {s.title || s.id || `Source ${i+1}`}
        </a>
      ))}
    </div>
  );
}
